// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"5497c029","251":"c15ff0ca","312":"a8aae66a","408":"ea26fa10","490":"e9ffa387","665":"17222bb6","787":"266fbae3"}[chunkId] + ".chunk.js";
};